import { getUrlConferenceApi } from '../utils/util';
import ApiHandler from './ApiHandler';
import {Filtro, DebitConferencePost} from '../interfaces/Conference';

export const baseURL = String(getUrlConferenceApi(window));

export default class ConferenceApi {
    static async search(filtro: Filtro) {
        var response = await ApiHandler(baseURL).get('debitconference/search', { params: filtro });
        return response.data.items;
    }

    static async create(data: DebitConferencePost) {
        var response = await ApiHandler(baseURL).post('debitconference', data);
        return response.data;
    }

    static async update(data: DebitConferencePost) {
        var response = await ApiHandler(baseURL).put('debitconference', data);
        return response.data;
    }

    static async get(id: string) {
        var response = await ApiHandler(baseURL).get('debitconference/'+id);
        return response.data;
    }

    static async delete(id: string) {
        var response = await ApiHandler(baseURL).delete('debitconference/'+id);
        return response.data;
    }
}
